import React from "react";
import BrandComponent from "../../Masters/Brand/BrandComponents";

const SalesOrderIndexTable = () => {
  let header = [
    { label: "Id", field: "id" },
    { label: "Status", field: "status" },
    { label: "Salesorder Type", field: "salesordertype" },
    { label: "Salesorder Category", field: "salesordercategory" },
    { label: "Customer Name", field: "customername" },
    { label: "Sales Order Number", field: "sono" },
    { label: "Sales Order Date", field: "sodate" },
  ];

  return (
    <BrandComponent
      header={header}
      tableTitle={"Sales Order LIST"}
      apiField={"salesOrder"}
      addButton={"+ ADD"}
      createRoute={"/createSalesOrder"}
      updateRoute={"/viewSalesOrder"}
      viewRoute={"/viewSalesOrder"}
    />
  );
};

export default SalesOrderIndexTable;
